<template>
    <Section v-if="items.length > 0" width="md">
        <div class="container" :class="{ 'text-left': textLeft }">
            <span 
                v-if="$validateText(slice.primary.text)" 
                class="rich-text" 
                v-html="$prismic.asHtml(slice.primary.text)" 
            />
            <ul :class="{ 'text-left': textLeft }">
                <li v-for="item in items" :key="item.id">
                    <nuxt-link :to="$prismic.linkResolver(item.page)" class="link">
                        <prismic-image 
                            v-if="item.icon && item.icon.url" 
                            :img="item.icon" 
                            w="40" 
                            h="40" 
                        />
                        <span>{{ item.label }}</span>
                        <i class="fas fa-arrow-right" />
                    </nuxt-link>
                </li>
            </ul>
        </div>
    </Section>
</template>

<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        items() {
            return this.slice.items
                .filter(item => this.$validateContentRelationship(item.page))
                .map(item => {
                    return {
                        page: item.page,
                        icon: item.page.data?.icon,
                        label: this.$validateText(item.label) 
                            ? item.label 
                            : item.page.data?.title || ''
                    };
                });
        },
        textLeft() {
            return this.slice.primary.text_position === 'left';
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;

    &.text-left {
        @include device(pad) {
            grid-template-columns: repeat(2, 1fr);
        }
        @include device(desktop) {
            grid-template-columns: 1fr 2fr;
        }
    }
    ul {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
        height: fit-content;
        @include device(pad) {
            &:not(.text-left) {
                grid-template-columns: repeat(2, 1fr);
            }
        }
        @include device(desktop) {
                grid-template-columns: repeat(2, 1fr);
        }

        li {    
            .link {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 1rem;
                border-radius: 10px;
                @include border();
                box-shadow: $bxs;
                padding: 0.5rem;
                font-weight: bold;

                span {
                    flex: 1;
                }
                i {
                    margin-right: 1rem;
                }

                &:hover {
                    color: $green;
                    span {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>